


export const navigateTo = (pathName) => {
    window.location.href = window.location.origin + pathName;
}
